import { useAppDispatch } from "hooks/useAppDispatch";
import { useCallback } from "react";
import { setPageTitle } from "store/slices/appLayout";

export const usePageTitleSetter = (): ((title: string | null) => void) => {
  const dispatch = useAppDispatch();

  return useCallback((title) => dispatch(setPageTitle(title)), [dispatch]);
};
